import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { ReactNode } from "react";
import { Controller, FieldError } from "react-hook-form";

type CheckBoxWithTextProps = {
  name: string;
  children?: string | ReactNode;
  required?: boolean;
  className?: string;
  control?: any;
  error?: FieldError | undefined;
  errorText?: string | undefined;
};

const CheckBoxWithText = ({
  children,
  required = false,
  control,
  error,
  errorText,
  className,
  name,
}: CheckBoxWithTextProps) => {
  return (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        rules={{ required: required ? `${errorText}` : false }}
        render={({ field }) => (
          <>
            <FormControlLabel
              control={<Checkbox {...field} />}
              label={children}
            />
            {error && <FormHelperText error>{errorText}</FormHelperText>}
          </>
        )}
      />
    </div>
  );
};

export default CheckBoxWithText;
